/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Link, Routes, Navigate, Route } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
// import "../../../../_metronic/_assets/sass/pages/users/login-1.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions/index";
import { getBaseImageURL } from "../../../../helpers";
import AuthLayout from "./AuthLayout";

export function AuthPage() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="registration" element={<Registration />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="" element={<Navigate to="/auth/login" />} />
      </Route>
    </Routes>
  );
}
